<template>
    <div ref="list">
        <div class="tw-space-y-5">
            <l-meeting-list-item
                v-for="meeting in meetings.slice(0, maxAmountVisible)"
                :key="meeting._id"
                :meeting="meeting"
                :current-user="user"
                :use-meridian-time="useMeridianTime"
            />
        </div>

        <l-user-profile-load-more
            :items="meetings"
            :value.sync="maxAmountVisible"
            :max-amount-visible="3"
            :scroll-to-element="$refs.list"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LMeetingListItem from "@/components/LMeetingListItem";
import LUserProfileLoadMore from "@/components/LUserProfile/LUserProfileLoadMore";

export default {
    components: {
        LMeetingListItem,
        LUserProfileLoadMore,
    },
    props: {
        meetings: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            maxAmountVisible: 3,
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            teamSettings: "users/current/teamSettings",
        }),
        useMeridianTime() {
            return this.teamSettings?.useMeridianTime;
        },
    },
};
</script>
